import { Box, useTheme } from "@mui/material";
import Header from "../../AdminComponents/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";

// FAQ Data
const faqData = [
  {
    question: "How do we choose the perfect destination?",
    answer: `
      <ul>
        <li>Research popular destinations, considering factors like budget, guest count, and personal preferences.</li>
        <li>Shortlist 2-3 options and consult with a travel agent or wedding planner.</li>
      </ul>`,
  },
  {
    question: "How do we plan a destination wedding from afar?",
    answer: `
      <ul>
        <li>Hire a local wedding planner or coordinator.</li>
        <li>Utilize video conferencing for meetings and venue tours.</li>
        <li>Create a detailed timeline and checklist.</li>
      </ul>`,
  },
  {
    question: "What do we expect from the event coordinator?",
    answer: `
      <ul>
        <li><strong>Expertise and Local Knowledge:</strong> Familiarity with local vendors, venues, and legal requirements. Experience in destination weddings to ensure seamless planning.</li>
        <li><strong>Personalization:</strong> Crafting a unique and personalized wedding experience.</li>
        <li><strong>Budget Management:</strong> Providing clear guidance on budgeting, cost-saving tips, and transparent vendor pricing.</li>
        <li><strong>Communication:</strong> Regular updates and prompt responses throughout the planning process.</li>
        <li><strong>Coordination of Logistics:</strong> Managing travel, accommodations, rehearsal dinners, and guest transportation.</li>
        <li><strong>Vendor Recommendations:</strong> Offering a list of trusted local vendors, such as caterers, photographers, and florists.</li>
        <li><strong>Timeline Development:</strong> Creating a detailed timeline with key milestones for the wedding day.</li>
        <li><strong>On-site Coordination:</strong> Overseeing the event, coordinating vendors, and ensuring everything runs smoothly.</li>
      </ul>`,
  },
  {
    question: "What are the costs associated with a destination wedding?",
    answer: `
      <ul>
        <li>Establish a budget and prioritize expenses.</li>
        <li>Research and compare vendor prices.</li>
        <li>Consider an all-inclusive resort or venue.</li>
        
      </ul>`,
      // <li><a href="#">Click here for detailed budget planning tips</a>.</li>
  },

  {
    question: "What's the best way to handle vendor selection?",
    answer: `
      <ul>
        <li>Research local vendors and read reviews.</li>
        <li>Conduct video interviews or meetings.</li>
        <li>Establish clear communication channels and contracts.</li>
      </ul>`,
  },
  {
    question: "What are the essentials to include in our destination wedding contract?",
    answer: `
      <ul>
        <li>Clearly outline vendor responsibilities and expectations.</li>
        <li>Include details on payment terms, cancellations, and refunds.</li>
        <li>Establish a communication plan and timeline.</li>
      </ul>`,
  },
];

const FAQ = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px" mt="80px">
      <Header
        title="FAQ"
        sx={{ fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.6rem" } }}
        subtitle="Frequently Asked Questions Page"
      />

      {faqData.map((faq, index) => (
        <Accordion key={index} defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography color={colors.greenAccent[500]} variant="h5">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQ;
